import { NzConfig } from "ng-zorro-antd/core/config";

export const ngZorroConfig: NzConfig = {
  theme: {
    primaryColor: 'red'
  }
};
